import { axiosInstance } from '../../../shared/api';

export async function singInRequest(userData) {
	try {
		const mfaSessionToken = localStorage.getItem('mfaSessionToken');
		const requestData = { ...userData };
		if (mfaSessionToken) {
			requestData.mfa_session_token = mfaSessionToken;
		}

		const response = await axiosInstance.post('auth/login', requestData);
		if (response.status === 200) {
			return response.data;
		}
	} catch (error) {
		return error;
	}
}

export async function verifyMFARequest(tempToken, code, mfaType) {
	try {
		const response = await axiosInstance.post('auth/mfa/verify', {
			temp_token: tempToken,
			code: code,
			mfa_type: mfaType,
		});
		if (response.status === 200) {
			return response.data;
		}
	} catch (error) {
		return error;
	}
}

export async function singnOutRequest() {
	try {
		const response = await axiosInstance.post(
			'auth/logout',
			{},
			{
				withCredentials: true,
			},
		);

		if (response.status === 200) {
			return 'ok';
		}
	} catch (error) {
		console.error(error);
	}
}

export async function singInByGoogle(userData) {
	try {
		const response = await axiosInstance.post(
			'auth/firebase/login',
			{ id_token: userData.id_token },
			{
				withCredentials: true,
				headers: {
					'Content-Type': 'application/json',
				},
			},
		);
		if (response.status === 200) {
			// Return the full response data (like singInRequest does) to handle MFA
			return response.data;
		}
	} catch (error) {
		console.error('Google sign-in error:', error);
		// Return the error so it can be handled upstream
		return error;
	}
}

export async function getUserInfo() {
	try {
		const response = await axiosInstance.get(`users/profile`, {
			withCredentials: true,
		});

		if (response.status === 200) {
			return response.data;
		}
	} catch (error) {
		console.error('Get user info error:', error);
		throw error;
	}
}
